// extracted by mini-css-extract-plugin
export default {"dropdownItem":"DropdownItem_dropdownItem__MpFRI","item":"DropdownItem_item__2BgT-"};